import { Dimmer, Loader, type DimmerProps } from 'semantic-ui-react';
import styled from 'styled-components';

const StyledDimmer = styled(Dimmer)`
  margin: 12px 10px;
  margin-left: 65px;
  height: calc(100% - 24px) !important;
`;

interface ILoaderBarProps extends Omit<DimmerProps, 'active' | 'inverted'> {
  content?: string;
}

export function LoaderBar({
  content = 'Loading',
  ...rest
}: ILoaderBarProps): JSX.Element {
  return (
    <Dimmer active inverted {...rest}>
      <Loader content={content} />
    </Dimmer>
  );
}

export function LoaderBarFullScreen({
  content = 'Loading',
  ...rest
}: ILoaderBarProps): JSX.Element {
  return (
    <StyledDimmer active inverted {...rest}>
      <Loader content={content} />
    </StyledDimmer>
  );
}
